export default __webpack_public_path__ + "static/media/image_hong_kong.bd998784.png";